import React from 'react';
import './FamilyShowcase.css';

const FAMILY_CATS = [
  {
    id: 'wedding',
    label: 'Wedding Photography',
    image: '/images/Website first page Family/Nikhil_01149_Wedding.jpg',
  },
  {
    id: 'upanayan',
    label: 'Thread Ceremony\nUpanayan',
    image: '/images/Website first page Family/Nikhil_9343_MunjaUpanayan.jpg',
  },
  {
    id: 'engagement',
    label: 'Engagement\nSession',
    image: '/images/Website first page Family/Nikhil_4302_Engagement.JPG',
  },
  {
    id: 'birthday',
    label: 'Birthday\nCelebration',
    image: '/images/Website first page Family/Nikhil_5708_Birthday.jpg',
  },
  {
    id: 'couple',
    label: 'Maternity\nShoot',
    image: '/images/Website first page Family/IMG_6263_BabyShower.jpg',
  },
  {
    id: 'kids',
    label: 'Kids & Family\nPortraits',
    image: '/images/Website first page Family/_NIK6394_BabyOrChildPhoto.JPG',
  },
  {
    id: 'fashion',
    label: 'Fashion',
    image: '/images/Fashion/6x8.jpg',
  },
];

const FamilyShowcase = ({ onCategoryClick }) => {
  const go = (cat) => onCategoryClick && onCategoryClick(cat);

  const rows = [
    FAMILY_CATS.slice(0, 2),
    FAMILY_CATS.slice(2, 4),
    FAMILY_CATS.slice(4, 6),
    FAMILY_CATS.slice(6, 7),
  ];

  return (
    <section className="fs-section">
      <div className="fs-header">
        <span className="fs-eyebrow">EXCLUSIVE COLLECTIONS</span>
        <h2 className="fs-title">Family Photography</h2>
        <p className="fs-subtitle">Capturing the essence of your most precious moments</p>
      </div>

      <div className="fs-canvas">
        {rows.map((row, ri) => (
          <div key={ri} className={`fs-row ${row.length === 1 ? 'fs-row--single' : ''}`}>
            {row.map((cat, ci) => (
              <div
                key={cat.id}
                className="fs-pair reveal-scale"
                onClick={() => go(cat)}
                style={{ animationDelay: `${(ri * 2 + ci) * 0.1}s` }}
              >
                <div className="fs-label">
                  <span>{cat.label}</span>
                </div>

                <div className="fs-photo">
                  <img src={cat.image} alt={cat.label} />
                  <div className="fs-photo-overlay">
                    <span className="view-text">View Gallery</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FamilyShowcase;
